import { Row,  } from "antd";
// import classes from "./Dashboard.module.css";
// import { Link } from "react-router-dom";
// import { PlusCircleOutlined } from "@ant-design/icons";
const DataCards = (props) => {
  // // console.log(props.employeeData.analysis);

  // // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  return <Row></Row>;
};

export default DataCards;
